import React from "react";

export default function About() {
  return (
    <div className="home">
      <div className="about">
        <h1>About Me</h1>
        <p>
          I am a software engineer currently working as assistant manager
          Information Technology at emirates supply chain services at
          Lahore,Pakistan. Have experience spanning more than ten years working
          on desktop and web applications for variety of industries.
        </p>
        <p>
          I am really passionate about learning new web and desktop technologies
          hence consider myself forever student. Eager to work for different
          companies/startups and contribute towards their development.
        </p>
        <p>
          Recently worked on WMS,HRMS,Accounts,Procurement systems,web portals.
        </p>
        <p>Ever ready for taking up new challanges.</p>
      </div>
    </div>
  );
}
